module.exports = __webpack_public_path__ + "img/fb.59cbdc20.svg";